// Module
var code = `<main class="page-content">
  <div data-region="main"></div>

  <!-- Pagination is centered on its own row, matching the invoices page -->
  <div data-region="pagination" class="mt-5 flex w-full justify-center"></div>
</main>
`;
// Exports
module.exports = code;